<template>
  <el-collapse-item name="3">
    <template slot="title">
      Autorizações Reversas&nbsp;<el-tag>{{ tableData.length }}</el-tag>
    </template>
    <el-table :data="tableData" size="small" stripe>
      <el-table-column sortable prop="authorization" :label="$t('autorizacao')" width="120" />
      <el-table-column sortable prop="name" :label="$t('nome')" min-width="90" show-overflow-tooltip />
      <el-table-column sortable prop="cpfcnpj" label="CPF/CNPJ" width="130" show-overflow-tooltip />
      <el-table-column prop="content" label="Conteúdo" min-width="120" show-overflow-tooltip />
      <el-table-column width="80" align="right">
        <template slot-scope="scope">
          <el-button type="danger" size="small" icon="el-icon-delete" @click.native.prevent="remove(scope.$index)"
            circle></el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-collapse-item>
</template>

<script>

export default {
  name: "PdvClosedReverse",
  data() {
    return {
      tableData: [],
    }
  },
  methods: {
    clear() {
      this.tableData = [];
    },
    remove(index) {
      const vm = this;
      vm.tableData.splice(index, 1);
      vm.$bus.$emit("pdv.removed");
    },
    add(data) {
      this.tableData.push(data);
    },
  },
}
</script>